import { createSignal, Show } from 'solid-js';
import { ThumbsDownIcon, ThumbsUpIcon } from '../Icons';
import { Feedback } from './../../types/constants';
import { FeedbackReason } from './FeedbackReason';
import classNames from 'classnames';

type AnswerResponseProps = {
  onFeedback: (feedback: Feedback) => void;
  onFeedbackReasonSubmit: (reason: string) => void;
};

export const AnswerResponse = (props: AnswerResponseProps) => {
  const [feedback, setFeedback] = createSignal(null as string | null);
  const [feedbackSubmitted, setFeedbackSubmitted] = createSignal(false);

  const feedbackMessage = `Thank you for your feedback!`;

  const handleThumbsUp = () => {
    if (feedback() !== Feedback.ACCEPT) {
      setFeedback(Feedback.ACCEPT);
      setFeedbackSubmitted(false); // reset feedback submitted state
      props.onFeedback && props.onFeedback(Feedback.ACCEPT);
    }
  };

  const handleThumbsDown = () => {
    if (feedback() !== Feedback.REJECT) {
      setFeedback(Feedback.REJECT);
      setFeedbackSubmitted(false); // reset feedback submitted state
      props.onFeedback && props.onFeedback(Feedback.REJECT);
    }
  };

  const handleReasonSubmit = (reason: string) => {
    setFeedbackSubmitted(true);
    props.onFeedbackReasonSubmit && props.onFeedbackReasonSubmit(reason);
  };

  return (
    // display thumbs up and down buttons
    // if thumbs up, display thank you message below the thumbs
    // if thumbs down, display the feedback reason textbox with cancel and submit button
    // keep the thumbs up and down buttons visible at all times.

    <div class="flex flex-col w-full justify-center items-center mt-4 p-1">
      {/* thumbs up and down buttons */}
      <div class="flex flex-row justify-between items-center self-end">
        <div class="flex flex-row">
          <button
            type="button"
            class={classNames(
              'text-[#737373] hover:text-[#33C99C] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#333333] rounded-md p-2',
              feedback() === Feedback.ACCEPT && 'text-[#33C99C] bg-green-100',
            )}
            onClick={handleThumbsUp}
          >
            <ThumbsUpIcon aria-hidden="true" />
            <span class="sr-only">Thumbs up</span>
          </button>
          <button
            type="button"
            class={classNames(
              'text-[#737373] hover:text-[#FF445E] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#333333] rounded-md p-2',
              feedback() === Feedback.REJECT && 'text-[#FF445E] bg-red-100',
            )}
            onClick={handleThumbsDown}
          >
            <ThumbsDownIcon aria-hidden="true" />
            <span class="sr-only">Thumbs down</span>
          </button>
        </div>
      </div>
      {/* thank you message */}
      <Show when={feedback() === Feedback.ACCEPT || feedbackSubmitted()}>
        <div class="self-end">
          <p class="text-sm text-gray-900 my-2.5">{feedbackMessage}</p>
        </div>
      </Show>
      <Show when={feedback() === Feedback.REJECT && !feedbackSubmitted()}>
        <FeedbackReason
          open={feedback() === Feedback.REJECT}
          onSubmit={handleReasonSubmit}
        />
      </Show>
    </div>
  );
};
